import { useComplaintDialog } from "./DialogContext";
import { ComplaintModalLayout } from "./ComplaintModalLayout";
import { getComplaintStatus } from "../../helpers/getComplaintStatus";
import DetailRow from "../../../../components/UI/viewDialogs/DetailRow";
import { checkValue } from "../../../../functions/checkValue";
import { timeStampToDateAndTime } from "../../../../functions/dateTime/timeStampToDateAndTime";
import { formatDate } from "../../../../functions/dateTime/formatDate";

ComplaintModalLayout.Details = function Details() {
  const { viewDetails } = useComplaintDialog();
  const statusColor = getComplaintStatus(viewDetails.status).textColor;
  return (
    <div className="view-dialog-content-wrap">
      <DetailRow title="Complaint ID" value={viewDetails.id} />
      <DetailRow
        title="Status"
        value={getComplaintStatus(viewDetails.status).status}
        valueColor={statusColor}
      />
      <DetailRow title="Category" value={viewDetails.category.name} />
      <DetailRow
        title="Description"
        value={checkValue(viewDetails.description)}
        textJustify="text-justify"
        widthDesc="w-64"
      />
      <DetailRow title="Site Id" value={checkValue(viewDetails.station.id)} />
      <DetailRow
        title="Site Name"
        value={checkValue(viewDetails.station.name)}
      />
      <DetailRow
        title="Assignee"
        value={checkValue(viewDetails.fieldTechnician.fullName)}
      />
      <DetailRow
        title="Created At"
        value={timeStampToDateAndTime(viewDetails.createdAt)}
      />
      {viewDetails.checkedAt && (
        <DetailRow
          title="Checked At"
          value={timeStampToDateAndTime(viewDetails.checkedAt)}
        />
      )}
      <DetailRow
        title="Created By"
        value={checkValue(viewDetails.createdBy.fullName)}
      />
      <DetailRow
        title="Received At"
        value={formatDate(viewDetails.receivedAt)}
      />
      <DetailRow title="Received By" value={viewDetails.receiver.fullName} />
      <DetailRow
        title="Supervisor"
        value={checkValue(viewDetails.supervisor.fullName)}
      />
      {(viewDetails.status === 1 || viewDetails.status === -1) && (
        <DetailRow
          title={`${viewDetails.status === 1 ? "Resolved At" : "Rejected At"}`}
          value={timeStampToDateAndTime(viewDetails.updatedAt)}
        />
      )}
      <DetailRow
        title="Phone No."
        value={checkValue(viewDetails.complainantPhoneNumber)}
      />
      <DetailRow
        title="Actual fault"
        value={checkValue(viewDetails.actualFault)}
      />
      <DetailRow
        title="Office Remark"
        value={checkValue(viewDetails.officeRemark)}
      />
      <DetailRow
        title="Number of visit"
        value={checkValue(
          viewDetails.visitIdList ? viewDetails.visitIdList.length : 0,
        )}
      />
      <DetailRow
        title="Last Visit"
        value={formatDate(viewDetails.last_visit_date)}
      />
    </div>
  );
};
